import { find, get, isBoolean, size, trim } from 'lodash-es';

/**
 * Check if value is null or undefined
 * @param {*} value
 */
export const checkIsNull = value => value === undefined || value === null;

/**
 * Check if value is null or undefined or empty
 * @param {*} value
 */
export const checkIsEmpty = value => value === undefined || value === null || value === '';

/**
 * Get Correct Value "for required Yup validation"
 * @param {*} value
 */
export const getCorrectValue = value => {
  if (isBoolean(value)) return value;

  const correctValue = size(trim(value)) > 0 ? trim(value) : undefined;
  return Array.isArray(value) ? value : correctValue;
};

/**
 * Check Conditions By Values
 * @param {*} param0
 */
export const checkConditionsByValues = ({ conditions, values }) => {
  try {
    // if array conditions is empty then return true
    if (size(conditions) <= 0) return undefined;
    // calculate result conditions
    const resultConditions = Object.keys(conditions).reduce((result, key) => {
      const valueCondition = get(conditions[key], 'value');
      const valueField = get(values, get(conditions[key], 'code'));
      const operatorCondition = get(conditions[key], 'operator');
      let resultConditionItem;
      //
      switch (operatorCondition) {
        case '=':
          resultConditionItem = valueField === valueCondition;
          break;
        case '>':
          resultConditionItem = valueField > valueCondition;
          break;
        case '<':
          resultConditionItem = valueField < valueCondition;
          break;
        case '>=':
          resultConditionItem = valueField >= valueCondition;
          break;
        case '<=':
          resultConditionItem = valueField <= valueCondition;
          break;
        default:
          resultConditionItem = valueField === valueCondition;
          break;
      }
      // by default the logical operator `&&` is applied for concatenated all conditions
      return result && resultConditionItem;
    }, true);
    return resultConditions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`checkConditionsByValues: ${e.stack}`);
  }
  return undefined;
};

/**
 * Sort by field
 * @param {string} field
 * @param a
 * @param b
 * @returns {number}
 */
export const sortByField = field => (a, b) => {
  if (get(a, field) > get(b, field)) {
    return 1;
  }
  if (get(b, field) > get(a, field)) {
    return -1;
  }
  return 0;
};

/**
 * Get by field
 * @param {string} field
 * @param data
 * @param value
 */
export const getByField =
  field =>
  ({ data, value }) =>
    find(data, d => get(d, field) === value);

/**
 * Add asterisk to mandatory field
 * @param {*} name
 * @param {*} validation
 */
export const addAsteriskMandatoryField = (name, validation) => {
  if (find(validation, { required: true })) return `${name} *`;
  return name;
};
